import React, {useRef, useState} from 'react';
import {Parallax, Navigation, Pagination, EffectCoverflow} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';
import {useQuickView} from "@/features/quickView/model/useQuickView";
import Link from "@/Layouts/Link";
import '@/Pages/Collections/scss/envie/envie.scss';

export default (props) => {
    const {uploadUrl = ''} = props;

    const videoRef = useRef(null);
    const swiperRef = useRef(null);

    const {openQuickView} = useQuickView();

    const [activeIndex, setActiveIndex] = useState(localStorage.getItem('activeIndexDesktop') || 0);
    const setActiveSlideDesktop = (swiper) => {
        setActiveIndex(swiper.activeIndex)
        localStorage.setItem('activeIndexDesktop', swiper.activeIndex)
        if (swiperRef.current !== null && swiperRef.current.swiper !== null) {
        }
    }

    /**
     * Воспроизведение / пауза видео
     */
    const [videoSvg, setVideoSvg] = useState(true);

    function mediaChange() {
        try {
            const video = videoRef.current;
            if (video.paused) {
                video.play();
                setVideoSvg(false);
            } else {
                video.pause();
                setVideoSvg(true);
            }
            video.onended = (e) => {
                setVideoSvg(true);
            };
        } catch (e) {
            console.log('e', e);
        }
    }

    const params = {
        speed: 1500,
        parallax: true,
        // lazy: true,
        initialSlide: activeIndex,
        // autoHeight: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        modules: [Parallax, Navigation, Pagination, EffectCoverflow],
        onSlideChange: (swiper) => {
            setActiveSlideDesktop(swiper);
        }
    }

    return (
        <section className={`section section__envie`}>
            <Swiper {...params}>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__one`}>
                            <img className={`sheet sheet__one`}
                                 src={`/storage/img/collections/envie/leaf-1.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-one.png`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__one`} data-swiper-parallax={`-3000`}>
                                <p className={`title title__one`}>Envie d'été</p>
                                <Link href={`/catalog/envie-dete`}
                                      className={`btn btn__envie`}
                                >
                                    Коллекция украшений
                                </Link>
                                <p className={`text`}>
                                    Ювелирный бренд PLATINA представляет серебряную коллекцию, вдохновлённую миром
                                    цветов и насекомых.
                                </p>
                                <p className={`text`}>
                                    Наши украшения в стиле флора и фауна станут модным элементом вашего чарующего
                                    летнего образа!
                                </p>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('03-3268-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/podveska1.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3268-00-204-0200-69`}
                                 title={`03-3268-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__two`}>
                            <div className={`envieContent envieContent__two`} data-swiper-parallax={`-3000`}>
                                <video ref={videoRef}
                                       preload={`none`}
                                       width={`100%`}
                                       poster={`/storage/img/collections/envie/desctop.jpg`}
                                >
                                    <source
                                        src={`${uploadUrl}/media/video/collections/envie/envie_mp4_16х9.mp4`}
                                        type={`video/mp4`} />
                                    <source
                                        src={`${uploadUrl}/media/video/collections/envie/envie_webm_16х9.webm`}
                                        type={`video/webm`} />
                                    <source
                                        src={`${uploadUrl}/media/video/collections/envie/envie_ogg_16х9.ogg`}
                                        type={`video/ogg`} />
                                </video>
                                <div className={`video-control`}>
                                    {videoSvg ?
                                        <>
                                            <div className={`gg-play-button`}
                                                 onClick={mediaChange}></div>
                                        </>
                                        :
                                        <>
                                            <div className={`gg-pause-button`}
                                                 onClick={mediaChange}></div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__three`}>
                            <img className={`sheet sheet__two`}
                                 src={`/storage/img/collections/envie/leaf-2.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__three`}
                                 src={`/storage/img/collections/envie/leaf-3.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-three.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__three`}
                                 data-swiper-parallax={`-3000`}>
                                <p className={`title title__three`}>Магия</p>
                                <p className={`subTitle subTitle__three`}>летних образов</p>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('03-3268-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/03-3268-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3268-00-204-0200-69`}
                                 title={`03-3268-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('02-4783-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/02-4783-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4783-00-204-0200-69`}
                                 title={`02-4783-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('01-5484-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/01-5484-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`01-5484-00-204-0200-69`}
                                 title={`01-5484-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__four `}
                                 onClick={() => openQuickView('05-0688-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/05-0688-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`05-0688-00-204-0200-69`}
                                 title={`05-0688-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__four`}>
                            <img className={`sheet sheet__four`}
                                 src={`/storage/img/collections/envie/leaf-4.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__five`}
                                 src={`/storage/img/collections/envie/leaf-5.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-four.png`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__four`}
                                 data-swiper-parallax={`-3000`}>
                                <p className={`title title__four`}>Красота</p>
                                <p className={`subTitle subTitle__four`}>чарующих силуэтов</p>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('03-3266-00-201-0200-68')}
                                 src={`/storage/img/collections/envie/03-3266-00-201-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3266-00-201-0200-68`}
                                 title={`03-3266-00-201-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('01-5483-00-201-0200-68')}
                                 src={`/storage/img/collections/envie/01-5483-00-201-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`01-5483-00-201-0200-68`}
                                 title={`01-5483-00-201-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('02-4781-00-201-0200-68')}
                                 src={`/storage/img/collections/envie/02-4781-00-201-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4781-00-201-0200-68`}
                                 title={`02-4781-00-201-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__four `}
                                 onClick={() => openQuickView('05-0682-00-201-0200-68')}
                                 src={`/storage/img/collections/envie/05-0682-00-201-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`05-0682-00-201-0200-68`}
                                 title={`05-0682-00-201-0200-68`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__five`}>
                            <img className={`sheet sheet__six`}
                                 src={`/storage/img/collections/envie/leaf-6.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-five.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__five`}
                                 data-swiper-parallax={`-3000`}>
                                <p className={`title title__five`}>Сияние</p>
                                <p className={`subTitle subTitle__five`}>бездонной лазури</p>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('03-3264-00-201-0200-69')}
                                 src={`/storage/img/collections/envie/03-3264-00-201-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3264-00-201-0200-69`}
                                 title={`03-3264-00-201-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('02-4779-00-201-0200-69')}
                                 src={`/storage/img/collections/envie/02-4779-00-201-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4779-00-201-0200-69`}
                                 title={`02-4779-00-201-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('05-0680-00-201-0200-69')}
                                 src={`/storage/img/collections/envie/05-0680-00-201-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`05-0680-00-201-0200-69`}
                                 title={`05-0680-00-201-0200-69`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__six`}>
                            <img className={`sheet sheet__seven`}
                                 src={`/storage/img/collections/envie/leaf-7.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__eight`}
                                 src={`/storage/img/collections/envie/leaf-8.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-six.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__six`}
                                 data-swiper-parallax={`-3000`}>
                                <p className={`title title__six`}>Феерия</p>
                                <p className={`subTitle subTitle__six`}>летних красок</p>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('03-3270-00-000-0200-68')}
                                 src={`/storage/img/collections/envie/03-3270-00-000-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3270-00-000-0200-68`}
                                 title={`03-3270-00-000-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('04-0259-00-000-0200-68')}
                                 src={`/storage/img/collections/envie/04-0259-00-000-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`04-0259-00-000-0200-68`}
                                 title={`04-0259-00-000-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('02-4785-00-000-0200-68')}
                                 src={`/storage/img/collections/envie/02-4785-00-000-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4785-00-000-0200-68`}
                                 title={`02-4785-00-000-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__four `}
                                 onClick={() => openQuickView('01-5485-00-000-0200-68')}
                                 src={`/storage/img/collections/envie/01-5485-00-000-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`01-5485-00-000-0200-68`}
                                 title={`01-5485-00-000-0200-68`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__seven`}>
                            <img className={`sheet sheet__nine`}
                                 src={`/storage/img/collections/envie/leaf-9.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__ten`}
                                 src={`/storage/img/collections/envie/leaf-10.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-seven.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__seven`}
                                 data-swiper-parallax={`-3000`}>
                                <p className={`title title__seven`}>Красота</p>
                                <p className={`subTitle subTitle__seven`}>истинных символов</p>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('03-3263-00-404-0200-68')}
                                 src={`/storage/img/collections/envie/03-3263-00-404-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3263-00-404-0200-68`}
                                 title={`03-3263-00-404-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('02-4778-00-404-0200-68')}
                                 src={`/storage/img/collections/envie/02-4778-00-404-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4778-00-404-0200-68`}
                                 title={`02-4778-00-404-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('05-0679-00-404-0200-68')}
                                 src={`/storage/img/collections/envie/05-0679-00-404-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`05-0679-00-404-0200-68`}
                                 title={`05-0679-00-404-0200-68`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__eight`}>
                            <img className={`sheet sheet__eleven`}
                                 src={`/storage/img/collections/envie/leaf-11.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__twelve`}
                                 src={`/storage/img/collections/envie/leaf-12.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-eight.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__eight`}
                                 data-swiper-parallax={`-3000`}>
                                <p className={`title title__eight`}>Настроение</p>
                                <p className={`subTitle subTitle__eight`}>яркого лета</p>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('03-3269-00-404-0200-68')}
                                 src={`/storage/img/collections/envie/03-3269-00-404-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3269-00-404-0200-68`}
                                 title={`03-3269-00-404-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('02-4784-00-404-0200-68')}
                                 src={`/storage/img/collections/envie/02-4784-00-404-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4784-00-404-0200-68`}
                                 title={`02-4784-00-404-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('05-0683-00-404-0200-68')}
                                 src={`/storage/img/collections/envie/05-0683-00-404-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`05-0683-00-404-0200-68`}
                                 title={`05-0683-00-404-0200-68`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__nine`}>
                            <img className={`sheet sheet__thirteen`}
                                 src={`/storage/img/collections/envie/leaf-13.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__fourteen`}
                                 src={`/storage/img/collections/envie/leaf-14.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-nine.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__nine`}
                                 data-swiper-parallax={`-3000`}>
                                <p className={`title title__nine`}>Сияние</p>
                                <p className={`subTitle subTitle__nine`}>фактуры цвета</p>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('03-3267-00-203-0200-68')}
                                 src={`/storage/img/collections/envie/03-3267-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3267-00-203-0200-68`}
                                 title={`03-3267-00-203-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('02-4782-00-203-0200-68')}
                                 src={`/storage/img/collections/envie/02-4782-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4782-00-203-0200-68`}
                                 title={`02-4782-00-203-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('05-0689-00-203-0200-68')}
                                 src={`/storage/img/collections/envie/05-0689-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`05-0689-00-203-0200-68`}
                                 title={`05-0689-00-203-0200-68`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__ten`}>
                            <img className={`sheet sheet__fifteen`}
                                 src={`/storage/img/collections/envie/leaf-15.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__sixteen`}
                                 src={`/storage/img/collections/envie/leaf-16.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-ten.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__ten`}
                                 data-swiper-parallax={`-3000`}>
                                <p className={`title title__ten`}>Феерия</p>
                                <p className={`subTitle subTitle__ten`}>ажурных силуэтов</p>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('02-4780-00-203-0200-69')}
                                 src={`/storage/img/collections/envie/02-4780-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4780-00-203-0200-69`}
                                 title={`02-4780-00-203-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('03-3265-00-203-0200-69')}
                                 src={`/storage/img/collections/envie/03-3265-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3265-00-203-0200-69`}
                                 title={`03-3265-00-203-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('01-5482-00-203-0200-69')}
                                 src={`/storage/img/collections/envie/01-5482-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`01-5482-00-203-0200-69`}
                                 title={`01-5482-00-203-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__four`}
                                 onClick={() => openQuickView('05-0687-00-203-0200-69')}
                                 src={`/storage/img/collections/envie/05-0687-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`05-0687-00-203-0200-69`}
                                 title={`05-0687-00-203-0200-69`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__eleven`}>
                            <img className={`sheet sheet__seventeen`}
                                 src={`/storage/img/collections/envie/leaf-17.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-eleven.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__eleven`}
                                 data-swiper-parallax={`-3000`}>
                                <p className={`title title__eleven`}>Романтика</p>
                                <p className={`subTitle subTitle__eleven`}>летних цветов</p>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('03-3272-00-206-0200-68')}
                                 src={`/storage/img/collections/envie/03-3272-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3272-00-206-0200-68`}
                                 title={`03-3272-00-206-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('01-5490-00-206-0200-68')}
                                 src={`/storage/img/collections/envie/01-5490-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`01-5490-00-206-0200-68`}
                                 title={`01-5490-00-206-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('02-4792-00-206-0200-68')}
                                 src={`/storage/img/collections/envie/02-4792-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4792-00-206-0200-68`}
                                 title={`02-4792-00-206-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__four`}
                                 onClick={() => openQuickView('05-0691-00-206-0200-68')}
                                 src={`/storage/img/collections/envie/05-0691-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`05-0691-00-206-0200-68`}
                                 title={`05-0691-00-206-0200-68`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__twelve`}>
                            <img className={`sheet sheet__eighteen`}
                                 src={`/storage/img/collections/envie/leaf-18.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__nineteen`}
                                 src={`/storage/img/collections/envie/leaf-19.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-twelve.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('03-3274-00-206-0200-68')}
                                 src={`/storage/img/collections/envie/03-3274-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3274-00-206-0200-68`}
                                 title={`03-3274-00-206-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('02-4796-00-206-0200-68')}
                                 src={`/storage/img/collections/envie/02-4796-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4796-00-206-0200-68`}
                                 title={`02-4796-00-206-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('02-4795-00-206-0200-68')}
                                 src={`/storage/img/collections/envie/02-4795-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4795-00-206-0200-68`}
                                 title={`02-4795-00-206-0200-68`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__thirteen`}>
                            <img className={`sheet sheet__twenty`}
                                 src={`/storage/img/collections/envie/leaf-21.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__twentyOne`}
                                 src={`/storage/img/collections/envie/leaf-20.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__twentyTwo`}
                                 src={`/storage/img/collections/envie/leaf-22.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-thirteen.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__thirteen`}
                                 data-swiper-parallax={`-3000`}>
                                <p className={`title title__thirteen`}>Магия</p>
                                <p className={`subTitle subTitle__thirteen`}>натуральных аметистов</p>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('02-4798-00-203-0200-68')}
                                 src={`/storage/img/collections/envie/02-4798-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4798-00-203-0200-68`}
                                 title={`02-4798-00-203-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('01-5492-00-203-0200-68')}
                                 src={`/storage/img/collections/envie/01-5492-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`01-5492-00-203-0200-68`}
                                 title={`01-5492-00-203-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('05-0694-00-203-0200-68')}
                                 src={`/storage/img/collections/envie/05-0694-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`05-0694-00-203-0200-68`}
                                 title={`05-0694-00-203-0200-68`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__fourteen`}>
                            <img className={`sheet sheet__twentyThree`}
                                 src={`/storage/img/collections/envie/leaf-23.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__twentyFour`}
                                 src={`/storage/img/collections/envie/leaf-24.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__twentyFive`}
                                 src={`/storage/img/collections/envie/leaf-25.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-fourteen.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('02-4799-00-203-0200-68')}
                                 src={`/storage/img/collections/envie/02-4799-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4799-00-203-0200-68`}
                                 title={`02-4799-00-203-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('02-4800-00-203-0200-68')}
                                 src={`/storage/img/collections/envie/02-4800-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4800-00-203-0200-68`}
                                 title={`02-4800-00-203-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('05-0693-00-203-0200-68')}
                                 src={`/storage/img/collections/envie/05-0693-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`05-0693-00-203-0200-68`}
                                 title={`05-0693-00-203-0200-68`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__fifteen`}>
                            <img className={`sheet sheet__twentySix`}
                                 src={`/storage/img/collections/envie/leaf-26.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__twentySeven`}
                                 src={`/storage/img/collections/envie/leaf-27.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-fifteen.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__fifteen`}
                                 data-swiper-parallax={`-3000`}>
                                <p className={`title title__fifteen`}>Настроение</p>
                                <p className={`subTitle subTitle__fifteen`}>летних приключений</p>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('03-3271-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/03-3271-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3271-00-204-0200-69`}
                                 title={`03-3271-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('02-4789-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/02-4789-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4789-00-204-0200-69`}
                                 title={`02-4789-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('05-0690-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/05-0690-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`05-0690-00-204-0200-69`}
                                 title={`05-0690-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__sixteen`}>
                            <img className={`sheet sheet__twentyEight`}
                                 src={`/storage/img/collections/envie/leaf-28.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__twentyNine`}
                                 src={`/storage/img/collections/envie/leaf-29.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-sixteen.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('02-4791-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/02-4791-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4791-00-204-0200-69`}
                                 title={`02-4791-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('02-4790-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/02-4790-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4790-00-204-0200-69`}
                                 title={`02-4790-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('01-5489-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/01-5489-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`01-5489-00-204-0200-69`}
                                 title={`01-5489-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__four`}
                                 onClick={() => openQuickView('02-4788-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/02-4788-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4788-00-204-0200-69`}
                                 title={`02-4788-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__seventeen`}>
                            <img className={`sheet sheet__thirty`}
                                 src={`/storage/img/collections/envie/leaf-30.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__thirtyOne`}
                                 src={`/storage/img/collections/envie/leaf-31.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__thirtyTwo`}
                                 src={`/storage/img/collections/envie/leaf-32.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-seventeen.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__seventeen`}
                                 data-swiper-parallax={`-3000`}>
                                <p className={`title title__seventeen`}>Романтика</p>
                                <p className={`subTitle subTitle__seventeen`}>летнего очарования</p>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('02-4797-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/02-4797-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4797-00-204-0200-69`}
                                 title={`02-4797-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('05-0692-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/05-0692-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`05-0692-00-204-0200-69`}
                                 title={`05-0692-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__eighteen`}>
                            <img className={`sheet sheet__thirtyThree`}
                                 src={`/storage/img/collections/envie/leaf-33.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__thirtyFour`}
                                 src={`/storage/img/collections/envie/leaf-34.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-eighteen.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('02-4793-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/02-4793-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4793-00-204-0200-69`}
                                 title={`02-4793-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('03-3273-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/03-3273-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3273-00-204-0200-69`}
                                 title={`03-3273-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('01-5491-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/01-5491-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`01-5491-00-204-0200-69`}
                                 title={`01-5491-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__four`}
                                 onClick={() => openQuickView('02-4794-00-204-0200-69')}
                                 src={`/storage/img/collections/envie/02-4794-00-204-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4794-00-204-0200-69`}
                                 title={`02-4794-00-204-0200-69`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={`bgSwiper`}></div>
                    <div className={`container`}>
                        <div className={`SwiperBox SwiperBox__nineteen`}>
                            <img className={`sheet sheet__thirtyFive`}
                                 src={`/storage/img/collections/envie/leaf-35.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img className={`sheet sheet__thirtySix`}
                                 src={`/storage/img/collections/envie/leaf-36.png`}
                                 data-swiper-parallax={`-100`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <img src={`/storage/img/collections/envie/slide-nineteen.png`}
                                // data-swiper-parallax={`-2000`}
                                 alt={`img`}
                                 title={`img`}
                                 loading={`lazy`}
                            />
                            <div className={`envieContent envieContent__nineteen`}
                                 data-swiper-parallax={`-3000`}>
                                <p className={`title description description__nineteen`}>
                                    Хотите ближе познакомиться с&nbsp;эффектными силуэтами бабочек, очаровательных
                                    жуков, лёгких ветвей и&nbsp;элегантных соцветий?
                                </p>
                                <Link href={`/catalog/envie-dete`}
                                      className={`subTitle subTitle__nineteen`}
                                >
                                    перейти к украшениям
                                </Link>
                            </div>
                            <img className={`imgSwiper imgSwiper__one`}
                                 onClick={() => openQuickView('02-4782-00-203-0200-68')}
                                 src={`/storage/img/collections/envie/02-4782-00-203-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`02-4782-00-203-0200-68`}
                                 title={`02-4782-00-203-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__two`}
                                 onClick={() => openQuickView('03-3269-00-404-0200-68')}
                                 src={`/storage/img/collections/envie/03-3269-00-404-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`03-3269-00-404-0200-68`}
                                 title={`03-3269-00-404-0200-68`}
                                 loading={`lazy`}
                            />
                            <img className={`imgSwiper imgSwiper__three`}
                                 onClick={() => openQuickView('01-5490-00-206-0200-68')}
                                 src={`/storage/img/collections/envie/01-5490-00-206-0200.png`}
                                 data-swiper-parallax={`-1000`}
                                 alt={`01-5490-00-206-0200-68`}
                                 title={`01-5490-00-206-0200-68`}
                                 loading={`lazy`}
                            />
                            <div className={`swiper-lazy-preloader`}></div>
                        </div>
                    </div>
                </SwiperSlide>
                <div className={`swiperButtonWrapper`}>
                    <div className={`swiper-button-prev envieDesktop swiper-button-white`}></div>
                    <div className={`swiper-button-next envieDesktop swiper-button-white`}></div>
                </div>
            </Swiper>
        </section>
    );
};
